import React from 'react'
import _ from 'lodash'
import { Switch, Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector, CategorySelector, BrandSelector,
} from '../../../components/inventory-components'
import { productGroupIdtoText } from '../utils'
import { theme } from '../../../styles/_variables'
import { BRAND, CATEGORY } from '../constants'

const { color } = theme

export default {
  columns: [{
    Header: () => <HeaderLabel>รหัสสินค้า</HeaderLabel>,
    accessor: 'sku',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 200,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ชื่อสินค้า</HeaderLabel>,
    accessor: 'productName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 350,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ยี่ห้อ</HeaderLabel>,
    accessor: 'brand',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <BrandSelector onChange={onChange} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ประเภทสินค้า</HeaderLabel>,
    accessor: 'productGroup',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{productGroupIdtoText(props.value)}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
      key='filter'
      data={[{ value: 'ALL', text: 'ทั้งหมด' }, { value: 'PARTS', text: 'อะไหล่' }, { value: 'OTHERS', text: 'อื่นๆ' }]}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 130,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>หมวดหมู่สินค้าสินค้า</HeaderLabel>,
    accessor: 'category',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <CategorySelector onChange={onChange}
    />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    id: 'stockSummary',
    Header: () => <HeaderLabel>จำนวนสินค้า/สต็อกขั้นต่ำ</HeaderLabel>,
    accessor: 'inventoryOptions[0]',
    sortable: false,
    filterable: true,
    Cell: (props) => {
      const stock = _.sumBy(props.value?.stockLocation, location => location.quantity)
      const minimumStock = props.value.minimumStock || 0
      const isLow = stock < minimumStock
      return (
        <CellText
          style={{
            color: isLow && color.primaryColor,
            fontWeight: isLow && 700,
          }}
        >
          {`${stock}/${minimumStock}`}
        </CellText>
      )
    },
    Filter: ({ onChange }) => (
      <div className='w-full flex justify-start items-center gap-x-2'>
        <Switch onChange={onChange} />
        <p className='text-xs font-medium'>แสดงเฉพาะสินค้า<br />ที่ต่ำกว่าสต็อกขั้นต่ำ</p>
      </div>
    ),
    filterMethod: (filter, row) => { console.info(filter, row) },
    width: 200,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ผู้จำหน่าย</HeaderLabel>,
    accessor: 'supplier[0].name',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
